export const SUBSCRIPTION_SMALL = 'subscription-small';
export const SUBSCRIPTION_MEDIUM = 'subscription-medium';
export const SUBSCRIPTION_BIG = 'subscription-big';
export const SUBSCRIPTION_UNLIMTIED = 'subscription-unlimited';

export const PRODUCT_COLORS = {
	[SUBSCRIPTION_SMALL]: 'turquoise',
	[SUBSCRIPTION_MEDIUM]: 'lime',
	[SUBSCRIPTION_BIG]: 'gold',
	[SUBSCRIPTION_UNLIMTIED]: 'orange',
};

export const PRODUCT_COLORS_LIGHT = {
	[SUBSCRIPTION_SMALL]: 'turquoise-light',
	[SUBSCRIPTION_MEDIUM]: 'lime-light',
	[SUBSCRIPTION_BIG]: 'gold-light',
	[SUBSCRIPTION_UNLIMTIED]: 'orange-light',
};
